const MenuTrackOrder = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M21.7765 15.1431C21.7765 15.1431 22.5108 12.9796 20.8031 11.616C19.8939 10.8883 19.3693 11.0063 18.1803 10.0032C17.0437 9.04605 16.729 7.26939 15.8664 6.48268C13.8963 4.70602 4.01125 4.87647 2.58328 5.22394C2.58328 5.22394 0.910504 17.241 1.00376 17.2541L3.91217 17.2607C3.81891 18.3424 3.97628 19.9093 5.70734 19.9093C7.95713 19.9093 8.21941 17.2148 8.21941 17.2148L14.0246 17.2082C14.0246 18.2768 14.3743 19.9945 15.9888 19.9945C18.0754 19.9945 18.5183 17.2869 18.5183 17.2869C18.5183 17.2869 21.52 17.2475 21.5958 17.2475C22.0446 17.2541 22.1436 15.5495 21.7765 15.1431ZM15.6799 10.8227C15.5283 10.9997 10.6033 10.8293 10.5916 10.7768C10.4517 9.58364 10.7023 7.2235 10.8655 7.1186C11.0287 7.00715 13.8031 7.04649 14.4326 7.84631C15.0562 8.63303 15.8722 10.5867 15.6799 10.8227Z"
            fill="#534E46"
        />
    </svg>
)

export default MenuTrackOrder
